import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bookmark } from "react-feather";
import { MdOutlineArrowForward } from "react-icons/md";
import { jobData } from "../data/data";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

export default function PopularJobsfour() {
  const [jobs, setJobs] = useState(jobData);

  
  const handleDragEnd = (result) => {
    const { destination, source } = result;

    
    if (!destination) return;

 
    const reorderedJobs = Array.from(jobs);
    const [removed] = reorderedJobs.splice(source.index, 1);
    reorderedJobs.splice(destination.index, 0, removed);

    setJobs(reorderedJobs);
  };
  //changes
 /*  useEffect(() => {
    const interval=setInterval(() => {
      if(jobs.length>1){
        const stimulatedResult={
          source:{index:0},
          destination:{index:jobs.length-1}
        }
        handleDragEnd(stimulatedResult);
      }
    } ,3000);
    return ()=>clearInterval(interval);
  },[jobs]); */
  return (
    <section className="relative bg-slate-50 dark:bg-slate-800 md:py-24 py-16">
      <div className="container">
        <div className="grid grid-cols-1 pb-8 text-center">
          <h3 className="mb-4 md:text-[26px] md:leading-normal text-2xl leading-normal font-semibold">
            Popular Jobs
          </h3>
          <p className="text-slate-400 max-w-xl mx-auto">
            Search all the open positions on the web. Get your own personalized
            salary estimate. Read reviews on over 30000+ companies worldwide.
          </p>
        </div>

        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="jobs">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 mt-8 gap-[30px]"
              >
                {jobs.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="group relative overflow-hidden bg-white dark:bg-slate-900 shadow hover:shadow-md dark:shadow-gray-700 dark:hover:shadow-gray-700 hover:-mt-2 rounded-md transition-all duration-500 h-fit"
                      >
                        <div className="p-6">
                          <div className="flex items-center">
                            <div className="w-14 h-14 min-w-[56px] flex items-center justify-center bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                              <img src={item.image} className="h-8 w-8" alt="" />
                            </div>

                            <div className="ms-3">
                              <Link
                                to={`/job-detail-three/${item.id}`}
                                className="inline-block text-[16px] font-semibold hover:text-emerald-600 transition-all duration-500 me-1"
                              >
                                {item.title}
                              </Link>
                              <span className="inline-block text-sm text-slate-400">{item.day}</span>
                              <div>
                                <span className="bg-emerald-600/10 inline-block text-emerald-600 text-xs px-2.5 py-0.5 font-semibold rounded-full me-1">
                                  {item.jobtype}
                                </span>
                                <span className="text-sm font-medium inline-block me-1">
                                  {item.deta}{" "}
                                  <span className="text-slate-400">{item.deta1}</span>
                                </span>
                                <span className="text-sm font-medium inline-block me-1">
                                  {item.deta2}{" "}
                                  <span className="text-slate-400">{item.deta3}</span>
                                </span>
                              </div>
                            </div>
                          </div>

                          <p className="text-slate-400 py-3">{item.headline}</p>

                          <div>
                            <span className="bg-slate-100 dark:bg-slate-800 inline-block text-slate-900 dark:text-slate-300 text-xs px-2.5 py-0.5 font-semibold rounded-full me-1">
                              HTML
                            </span>
                            <span className="bg-slate-100 dark:bg-slate-800 inline-block text-slate-900 dark:text-slate-300 text-xs px-2.5 py-0.5 font-semibold rounded-full me-1">
                              CSS
                            </span>
                          </div>
                        </div>

                        <div className="px-6 py-2 bg-slate-50 dark:bg-slate-800 lg:flex justify-between items-center">
                          <div className="lg:inline-block flex justify-between items-center">
                            <span className="inline-block me-1 font-semibold">
                              {item.verify}
                            </span>
                          </div>
                             
                          <Link
                            to="/job-apply"
                            className="btn btn-sm rounded-md bg-emerald-600 hover:bg-emerald-700 border-emerald-600 hover:border-emerald-700 text-white md:ms-2 w-full lg:w-auto lg:mt-0 mt-4"
                          >
                            {item.apply}
                          </Link>
                        </div>

                        <Link
                          to="/"
                          className="btn btn-icon rounded-full bg-emerald-600/5 hover:bg-emerald-600 border-emerald-600/10 hover:border-emerald-600 text-emerald-600 hover:text-white absolute top-0 end-0 m-3"
                        >
                          <Bookmark className="h-4 w-4"></Bookmark>
                        </Link>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        <div className="grid md:grid-cols-12 grid-cols-1 mt-8">
          <div className="md:col-span-12 text-center">
            <Link
              to="/job-grid-two"
              className="btn btn-link text-slate-400 hover:text-emerald-600 after:bg-emerald-600 duration-500 ease-in-out inline-flex items-center"
            >
              See More Jobs <MdOutlineArrowForward className="m-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
